import { InventoryFeature } from '@/components/features/inventory/InventoryFeature'

export const InventoryDashboard = () => {
  return <InventoryFeature />
}
